import { useEffect } from 'react';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import SetList from '@/components/sets/SetList';
import SetDetail from '@/components/sets/SetDetail';
import { useParams, useNavigate } from 'react-router-dom';
import { useEffectiveSetList } from '@/hooks/useEffectiveSetList';
import EmptyState from '@/components/common/EmptyState';
import Spinner from '@/components/common/Spinner';

export default function SetsPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const isMobile = useMediaQuery('(max-width: 767px)');
  const { sets, isLoading } = useEffectiveSetList();

  // On desktop, auto-select the first set if none is selected
  useEffect(() => {
    if (!isMobile && !id && sets.length > 0) {
      navigate(`/app/sets/${sets[0].set_id}`, { replace: true });
    }
  }, [isMobile, id, sets, navigate]);

  // On mobile, show either the list or the detail view
  if (isMobile) {
    if (id) {
      return <SetDetail />;
    }
    return <SetList />;
  }

  // On desktop, the sidebar handles the list; this page shows the detail view
  if (id) {
    return <SetDetail />;
  }

  // While loading, show a spinner instead of the empty state to avoid a flash
  if (isLoading) {
    return (
      <div className="flex h-full items-center justify-center">
        <Spinner />
      </div>
    );
  }

  // No sets exist — show empty state
  return (
    <div className="flex h-full items-center justify-center">
      <EmptyState
        title="Select a set"
        description="Choose a set from the sidebar to see its details"
        icon={
          <svg className="h-16 w-16" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
            />
          </svg>
        }
      />
    </div>
  );
}
